/**
 * Lead capture service — handles email subscription for the popup
 * Completely separate from the auth/newsletter flow
 */
import apiClient from './apiClient';

const leadService = {
  /**
   * Subscribe an email to the lead capture list (Empty Leg Deals)
   * @param {string} email - User's email address
   * @param {string} honeypot - Honeypot field value (must be empty for real users)
   * @returns {Promise<{ success: boolean, message: string }>}
   */
  subscribe: async (email, honeypot = '', context = {}) => {
    return apiClient.post('/newsletter/subscribe', {
      email,
      website: honeypot,
      route: context.route,
      triggerType: context.triggerType
    });
  },

  /**
   * Get the lead-subscription status for the currently authenticated user.
   * Used to suppress the popup across devices once the user has subscribed.
   * Returns `{ subscribed: false }` for anonymous visitors — never throws.
   */
  getStatus: async () => {
    try {
      return await apiClient.get('/lead/status');
    } catch {
      return { success: false, subscribed: false };
    }
  },

  getPopupStatus: async (route) => {
    return apiClient.get('/newsletter/popup-status', { route });
  },

  suppressPopup: async ({ reason, route, triggerType }) => {
    return apiClient.post('/newsletter/popup-suppress', {
      reason,
      route,
      triggerType
    });
  },

  trackPopupEvent: async ({ eventName, route, triggerType }) => {
    return apiClient.post('/newsletter/popup-event', {
      eventName,
      route,
      triggerType
    });
  }
};

export default leadService;
